import React from 'react';
import styled from 'styled-components';


const ContainerWrapper = styled.div<{ backgroundColor?: string, noPadding?: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;
  padding-right: ${({ noPadding }) => (noPadding ? '0' : '15px')};
  padding-right: ${({ noPadding }) => (noPadding ? '0' : '15px')};
  margin-right: auto;
  margin-left: auto;
  background-color: ${({ backgroundColor }) => (backgroundColor === null ? 'transparent' : backgroundColor)};
`;

interface ContainerFullWidthProps {
  children: object,
  backgroundColor?: string,
  noPadding?: boolean,
}

const ContainerFullWidth = ({ noPadding, children, backgroundColor }: ContainerFullWidthProps) => (
  <ContainerWrapper
    backgroundColor={backgroundColor}
    noPadding={noPadding}
  >
    {children}
  </ContainerWrapper>
);

export default ContainerFullWidth;
